export default __webpack_public_path__ + "static/media/GR6 6A-2EC.e063eff5.jpg";